import { all } from 'redux-saga/effects';
import reportingSaga from './modules/report/common/redux/sagas/index';
import postalOperatorsSaga from './modules/wizard/target-node-impc-selector/redux/sagas';
import mrdPostalOperatorsSaga from './modules/wizard/target-node-mrd-impc-selector/redux/sagas';
import carriersSaga from './modules/wizard/target-node-carrier-selector/redux/sagas';
import handlersSaga from './modules/wizard/target-node-handler-selector/redux/sagas';
import reportsSaga from './modules/wizard/target-node-report-selector/redux/sagas';
import operatorUserSaga from './modules/wizard/target-node-operator-user-selector/redux/sagas';
import postalOperatorsMailboxSaga from './modules/wizard/target-node-mailbox-selector/redux/sagas';
import postalOperatorsUnlocodeSaga from './modules/wizard/target-node-unlocode-selector/redux/sagas';
import productSelectorSaga from './modules/wizard/product-selector/redux/sagas';

function* rootSaga() {
  yield all([
    postalOperatorsSaga(),
    mrdPostalOperatorsSaga(),
    carriersSaga(),
    handlersSaga(),
    reportsSaga(),
    operatorUserSaga(),
    postalOperatorsMailboxSaga(),
    postalOperatorsUnlocodeSaga(),
    reportingSaga(),
    productSelectorSaga(),
  ]);
}

export default rootSaga;
